
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"stroke":"#5FB8EE","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}},[_c('path',{attrs:{"d":"M42 54.5H14.268a2.75 2.75 0 01-2.748-2.75v-39.5a2.75 2.75 0 012.748-2.75h26c1.52 0 2.75 1.23 2.752 2.75v15.244"}}),_c('path',{attrs:{"d":"M32.02 36.5h-13a1.5 1.5 0 00-1.5 1.5v9a1.5 1.5 0 001.5 1.5h14M17.52 42.5h13.5M26.52 36.5v12"}})]),_c('path',{attrs:{"fill":"#5FB8EE","fill-rule":"nonzero","d":"M31.215 16.8l.117.007.127.023.108.034.136.063.071.044.087.066.061.056 2.828 2.828.084.095a1 1 0 01-1.404 1.403l-.094-.083-1.122-1.121V27.8l-.006.117a1 1 0 01-1.993-.117v-7.585l-1.121 1.12-.095.084a1 1 0 01-1.32-1.498l2.829-2.828c.028-.028.057-.054.094-.083l.09-.062.1-.054.08-.034.14-.04.086-.013.117-.007zm-7.657 0a1 1 0 01.993.883l.007.117v7.585l1.121-1.12.095-.084a1 1 0 011.403 1.403l-.083.095-2.829 2.828-.06.056-.088.066-.071.044-.136.063-.108.034-.127.023-.117.007-.117-.007-.086-.014-.14-.04-.08-.033-.1-.054-.09-.062a1.048 1.048 0 01-.094-.083l-2.829-2.828a1 1 0 011.32-1.498l.095.083 1.12 1.121.001-7.585a1 1 0 011-1z"}}),_c('path',{attrs:{"stroke":"#5FB8EE","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M34.859 41.149c0 5.523 4.477 10 10 10s10-4.477 10-10-4.477-10-10-10-10 4.477-10 10z"}}),_c('path',{attrs:{"stroke":"#5FB8EE","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M48.192 41.149h-3.333v-5"}})])])
          )
        }
      }
    